import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle, ArrowLeft, Mail, Calendar } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const Tack = () => {
  const { language } = useLanguage();
  useEffect(() => {
    // GA4 tracking for thank you page
    if (typeof window !== 'undefined' && (window as any).gtag) {
      (window as any).gtag('event', 'form_submit', {
        event_category: 'engagement',
        event_label: 'contact_form',
        value: 1
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-subtle flex items-center justify-center px-4">
      <Card className="max-w-2xl w-full shadow-elegant border-border/50 bg-gradient-card backdrop-blur-sm">
        <CardContent className="p-8 text-center">
          <div className="w-20 h-20 rounded-full bg-gradient-primary flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-10 h-10 text-white" />
          </div>
          
          <h1 className="text-3xl md:text-4xl font-bold mb-4">
            <span className="hero-text">
              {language === 'sv' ? 'Tack för ditt meddelande!' : 'Thank you for your message!'}
            </span>
          </h1>
          
          <p className="text-lg text-muted-foreground mb-6 leading-relaxed">
            {language === 'sv' ? 
              'Vi har tagit emot din förfrågan och kommer att återkomma till dig inom 24 timmar. Vi ser fram emot att hjälpa dig skapa fantastiska videofilmer med vår AI-teknologi.' :
              'We have received your request and will get back to you within 24 hours. We look forward to helping you create amazing videos with our AI technology.'
            }
          </p>
          
          <div className="space-y-4 mb-8">
            <div className="flex items-center justify-center gap-3 text-muted-foreground">
              <Mail className="w-5 h-5" />
              <span>
                {language === 'sv' ? 'Ett bekräftelsemail skickas till dig inom kort' : 'A confirmation email will be sent to you shortly'}
              </span>
            </div>
            <div className="flex items-center justify-center gap-3 text-muted-foreground">
              <Calendar className="w-5 h-5" />
              <span>
                {language === 'sv' ? 'Vi återkommer inom 24 timmar' : 'We will get back to you within 24 hours'}
              </span>
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild variant="outline" className="bg-background/50">
              <Link to="/">
                <ArrowLeft className="mr-2 w-4 h-4" />
                {language === 'sv' ? 'Tillbaka till startsidan' : 'Back to homepage'}
              </Link>
            </Button>
            
            <Button asChild className="bg-gradient-primary border-0 hover:opacity-90">
              <a 
                href="https://calendly.com/andreas-aihackers/30-min-mote"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Calendar className="mr-2 w-4 h-4" />
                {language === 'sv' ? 'Boka ett möte direkt' : 'Book a meeting directly'}
              </a>
            </Button>
          </div>
          
          <div className="mt-8 pt-6 border-t border-border/50">
            <p className="text-sm text-muted-foreground">
              {language === 'sv' ? (
                <>
                  Har du frågor? Kontakta oss på{" "}
                  <a href="mailto:hello@explainervideo.se" className="text-primary hover:underline">
                    hello@explainervideo.se
                  </a>{" "}
                  eller ring{" "}
                  <a href="tel:+46107502866" className="text-primary hover:underline">
                    +46 10 750 28 66
                  </a>
                </>
              ) : (
                <>
                  Have questions? Contact us at{" "}
                  <a href="mailto:hello@explainervideo.se" className="text-primary hover:underline">
                    hello@explainervideo.se
                  </a>{" "}
                  or call{" "}
                  <a href="tel:+46107502866" className="text-primary hover:underline">
                    +46 10 750 28 66
                  </a>
                </>
              )}
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default Tack;